import {
  isRecaptchaEnabled,
  preloadRecaptcha,
  executeRecaptcha,
  retainBadge,
  releaseBadge
} from '@/services/recaptcha'

/**
 * Mixin para formularios publicos protegidos por reCAPTCHA v3.
 *
 * Carrega o script ao montar (para o selo aparecer junto com o formulario) e o
 * esconde ao sair da pagina. O token e gerado apenas no submit, via
 * `this.getRecaptchaToken('<acao>')`.
 */
export default {
  data() {
    return {
      recaptchaEnabled: isRecaptchaEnabled()
    }
  },
  mounted() {
    this._recaptchaBadgeRetained = true
    retainBadge()
    preloadRecaptcha()
  },
  destroyed() {
    // O Vue dispara `destroyed` mesmo em instancias criadas e descartadas sem nunca
    // montar — o que acontece nos redirects dos guards de rota. Sem este pareamento
    // sobraria um release sem retain e o selo sumiria em uma pagina protegida.
    if (!this._recaptchaBadgeRetained) return

    this._recaptchaBadgeRetained = false
    releaseBadge()
  },
  methods: {
    getRecaptchaToken(action) {
      return executeRecaptcha(action)
    }
  }
}
